import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function ButtonWithConfirmationDialog({
    button,
    title,
    confirmBtnText,
    onConfirm,
    isDangerous,
    children,
}) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {button(handleOpen)}

            <Dialog
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>
                    {title}
                </DialogTitle>

                <DialogContent>
                    {children}
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        color={isDangerous ? 'error' : 'primary'}
                        onClick={() => {
                            onConfirm();
                            handleClose();
                        }}
                    >
                        {confirmBtnText}
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
